import React from 'react';

/**
 * ローディングスピナーコンポーネント
 * @param {boolean} [centered] - 管理画面パネル内で中央配置する
 * @param {string} [message] - centered 時に表示するメッセージ
 */
const LoadingSpinner = ({
  size = 'medium',
  className = '',
  message = null,
  centered = false
}) => {
  const sizeClass = size === 'small' ? 'small' : size === 'large' ? 'large' : '';
  const spinner = (
    <div className={`spinner ${sizeClass} ${className}`.trim()} aria-hidden="true" />
  );

  if (!centered && !message) {
    return spinner;
  }

  return (
    <div className="admin-panel-loading" role="status" aria-live="polite">
      {spinner}
      {message && <p>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
